import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Center,
  ModalFooter,
  Spinner,
  useMediaQuery,
  useToast,
} from "@chakra-ui/react";
import { capitalize, isEmpty, omit } from "lodash";
import { compare } from "../../../../utils/helpers";
import ModalWrapper from "../../ModalWrapper";
import { UPDATE_USER } from "./mutations";
import { GET_USER } from "./queries";
import UpdateUserForm from "./UserUpdateForm";

type UserUpdateProps = {
  onOpen: () => void;
  onClose: () => void;
  isOpen: boolean;
  id: string;
  refetch?: any;
  title?: any;
  disabledFields?: string[];
};

const UserUpdate = (props: UserUpdateProps) => {
  const { isOpen, onClose, id, refetch, title, disabledFields } = props;

  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");
  const formName = "createUserForm";
  const [updateUser, { loading: Updating }] = useMutation(UPDATE_USER);
  const toast = useToast();

  const { data, loading } = useQuery(GET_USER, {
    variables: {
      id,
    },
    fetchPolicy: "network-only",
  });

  const initialValues = {
    ...omit(data?.user, ["__typename"]),
  };

  const onSubmit = (values: any) => {
    const fields = compare(initialValues, values);

    let omitFields: any = [];

    return updateUser({
      variables: {
        inputs: [
          {
            id,
            ...omit(fields, omitFields),
          },
        ],
      },
    })
      .then((data: any) => {
        if (data) {
          onClose();
          refetch && refetch();
          if (!toast.isActive("active-toast")) {
            toast({
              id: "active-toast",
              title: "Updated succesfully",
              description: `${capitalize(
                data?.data.userUpdate[0].name
              )} was updated`,
              status: "success",
              duration: 3000,
              isClosable: true,
              variant: "solid",
              position: !isLargerThan900 ? "bottom-left" : "bottom",
            });
          }
        }
      })
      .catch((error) => {
        if (!toast.isActive("active-toast")) {
          toast({
            id: "active-toast",
            title: error.message,
            description: "Please, try again.",
            status: "error",
            duration: 2000,
            isClosable: true,
            variant: "solid",
            position: !isLargerThan900 ? "bottom-left" : "bottom",
          });
        }
      });
  };

  return (
    <ModalWrapper
      onClose={onClose}
      isOpen={isOpen}
      title={loading ? "" : `${capitalize(data?.user?.name)} | Update`}
      size="xl"
    >
      {loading ? (
        <Center py="5">
          <Spinner />
        </Center>
      ) : (
        <UpdateUserForm
          onSubmit={onSubmit}
          formName={formName}
          initialValues={initialValues}
          disabledFields={disabledFields}
        />
      )}

      <ModalFooter>
        <Button mr="3" w={isLargerThan900 ? "50" : "full"} onClick={onClose}>
          Cancel
        </Button>
        <Button
          w={isLargerThan900 ? "50" : "full"}
          form={formName}
          colorScheme="whatsapp"
          type="submit"
          isLoading={loading || Updating}
          isDisabled={loading || Updating}
        >
          Update
        </Button>
      </ModalFooter>
    </ModalWrapper>
  );
};

export default UserUpdate;
